var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"diagramOutline"},[_c('div',{ref:"diagramContainer",staticClass:"diagramGrabber",class:{ 'is-dragging': _vm.isDragging },staticStyle:{"overflow":"auto"},on:{"mousedown":_vm.startDrag}},[_c('div',{ref:"diagram",staticClass:"diagramWrapper"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }